import { render } from "./IndividualCustomer.vue?vue&type=template&id=c5538016&scoped=true&ts=true"
import script from "./IndividualCustomer.vue?vue&type=script&lang=ts"
export * from "./IndividualCustomer.vue?vue&type=script&lang=ts"

import "./IndividualCustomer.vue?vue&type=style&index=0&id=c5538016&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5538016"]])

export default __exports__